export default "__VITE_ASSET__BmQiF$hM__"